import * as React from "react";
import {cx} from "emotion";

import "./select-address-modal.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {UseState}       from "@Common/react/use-state";
import {ConfirmModal}   from "@Common/ui-components/confirm-modal/confirm-modal";
import {Radio}          from "@Common/ui-components/heavy/common/design2/radio/radio";
import {ModalService3}  from "@Common/ui-components/modal-service-3/modal-service-3";

import {AddShippingAddressModal}  from "@Xpresso/routes/account/common/shipping-addresses-panel/modals/add-shipping-address-modal/add-shipping-address-modal";
import {EditShippingAddressModal} from "@Xpresso/routes/account/common/shipping-addresses-panel/modals/edit-shipping-address-modal/edit-shipping-address-modal";
import {LoadingPanel}             from "@Xpresso/routes/common/loading-panel/loading-panel";

export const SelectAddressModal = ({selectedAddressId, officeAddress, myAddresses, agentId=undefined, next: rootNext}) => cs(
    consumeContext("apis"),
    ["modal", ({}, next) => ModalService3({
        xdQaName: "Select Address Modal",
        next: ({params: {onChangeAddressId}, close}) => next({
            onChangeAddressId,
            close,
        }),
        // autoRender: false,
        rootNext,
    })],
    ["confirmModal", ({}, next) => ConfirmModal({next})],
    ["addAddressModal", ({}, next) => AddShippingAddressModal({agentId, next})],
    ["submitting", (_, next) => UseState({next})],
    ({modal, confirmModal, submitting, addAddressModal, apis}) => (
        <div className="select-address-modal-4dx">
            <div className="header" xd-qa-type="label" xd-qa-name="Select Shipping Address">
                Select Shipping Address
            </div>

            <div className="addresses">
                {[officeAddress.value, ...myAddresses.value || []].filter(v=>v).filter((q, idx, v) => v.findIndex(obj => obj.idPrimary === q.idPrimary) === idx).map((address) => {
                    const selected = address.idPrimary === selectedAddressId;
                    return (
                        <div
                            className={cx("address", {selected})} key={address.idPrimary}
                            onClick={async () => {
                                if (!selected) {
                                    submitting.onChange(true);
                                    try {
                                        await modal.onChangeAddressId(address.idPrimary);
                                        modal.close();
                                    } finally {
                                        submitting.onChange(false);
                                    }
                                }
                            }}
                            xd-qa-type="card"
                            xd-qa-name={address.contactName}
                        >
                            <div
                                className="toggle"
                            >
                                <div className="checkbox">
                                    <Radio xdQaName="Radio" {...{selected}}/>
                                </div>

                                <div className="main">
                                    <div className="line1">
                                        <div className="name" xd-qa-type="label" xd-qa-name="Contact Name">
                                            {address.contactName}
                                        </div>
                                        {Controls({
                                            address,
                                            myAddresses,
                                            onEdited: async (addressId) => {
                                                try {
                                                    submitting.onChange(true);
                                                    await modal.onChangeAddressId(addressId);
                                                    modal.close();
                                                } finally {
                                                    submitting.onChange(false);
                                                }
                                            },
                                            onRemove: !selected && (async () => {
                                                confirmModal.show({
                                                    messageLines: [
                                                        "Delete this shipping address?"
                                                    ],
                                                    confirm: async () => {
                                                        myAddresses.onChange(myAddresses.value.filter((a) => a.idPrimary !== address.idPrimary));
                                                        await apis.next.shipping.deleteShippingAddress(address.idPrimary, {agentId});
                                                    }
                                                })
                                            })
                                        })}
                                    </div>

                                    <div className="details">
                                        <div className="line" xd-qa-type="label" xd-qa-name="Address">
                                            {address.address1}, {address.city} {address.state} {address.postalCode}
                                        </div>
                                        <div className="line" xd-qa-type="label" xd-qa-name="Phone">
                                            {address.contactPhone}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    );
                })}

                {(officeAddress.loading || myAddresses.loading) && (
                    <div className="loading" xd-qa-type="label" xd-qa-name="Loading">
                        Loading addresses...
                    </div>
                )}
            </div>

            <div className="actions">
                <div className="links">
                    <a
                        xd-qa-type="link"
                        xd-qa-name="Add New Shipping Address"
                        onClick={() => addAddressModal.show({
                            onDone: async (address) => {
                                myAddresses.onChange([
                                    address,
                                    ...myAddresses.value,
                                ]);
                                try {
                                    submitting.onChange(true);
                                    await modal.onChangeAddressId(address.idPrimary);
                                    modal.close();
                                } finally {
                                    submitting.onChange(false);
                                }
                            }
                        })}
                    >
                        Add New Address
                    </a>
                </div>
            </div>

            {submitting.value && (
                LoadingPanel({})
            )}
        </div>
    ),
);


const Controls = ({address, myAddresses, onEdited, onRemove}) => cs(
    ["editAddressModal", ({}, next) => EditShippingAddressModal({next})],
    ({editAddressModal}) => (
        <div className="controls">
            {myAddresses.value?.find((a) => a.idPrimary === address.idPrimary) && (
                <>
                    <a
                        xd-qa-type="link"
                        xd-qa-name="Edit"
                        className="edit"
                        onClick={async (e) => {
                            e.stopPropagation();
                            editAddressModal.show({
                                lockedAsDefault: address.defaultBranch,
                                address,
                                onDone: async (address) => {
                                    myAddresses.onChange(myAddresses.value.map((a) => a.idPrimary !== address.idPrimary ? a : address));
                                    onEdited(address.idPrimary);
                                },
                            });
                        }}
                    >
                        Edit
                    </a>

                    {onRemove && (
                        <a
                            xd-qa-type="link"
                            xd-qa-name="Remove"
                            className="remove"
                            onClick={async (e) => {
                                e.stopPropagation();
                                await onRemove();
                            }}
                        >
                            Remove
                        </a>
                    )}
                </>
            )}
        </div>
    ),
);
